import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { DeleteDataSourceVersionsRequest } from '../../ts/ServerApi/requests/DeleteDataSourceVersionsRequest';
import {
  GetDatasourceVersionsRequest,
  IGetDatasourceVersionsResult,
} from '../serverApi/requests/getDatasourceVersionsRequest';
import { IDatasourceRevision } from '../serverApi/types/IDatasourceRevision';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { Resource } from '../../ts/resources/Resource';
import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';

class DatasourceRevisions {

  private fetcher = new WebClientListResourceFetcher<IDatasourceRevision, IGetDatasourceVersionsResult>(
      GetDatasourceVersionsRequest,
      (result: IGetDatasourceVersionsResult) => result.versions);

  public del = (id: string): Promise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteDataSourceVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public all(): ResourceQuery<IDatasourceRevision> {
    return new ResourceQuery(this.fetcher);
  }

}

export const DatasourceRevisionsInstance = new DatasourceRevisions();
export type {DatasourceRevisions};
